import script from "./AccordionItemDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionItemDescription.vue?vue&type=script&setup=true&lang=js"

import "./AccordionItemDescription.vue?vue&type=style&index=0&id=f4c52ea2&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4c52ea2"]])

export default __exports__